export default "__VITE_ASSET__CNVah38E__"